import { render } from "./Texasauto.vue?vue&type=template&id=e167b98e&scoped=true"
import script from "./Texasauto.vue?vue&type=script&lang=js"
export * from "./Texasauto.vue?vue&type=script&lang=js"

import "./Texasauto.vue?vue&type=style&index=0&id=e167b98e&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e167b98e"]])

export default __exports__